import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock, LogIn } from "lucide-react";
import { toast } from "sonner";
import { adminApi } from "@/lib/api";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await adminApi.post("/admin/login", form);
      toast.success("Welcome back, admin!");
      navigate("/admin");
    } catch {
      toast.error("Invalid email or password.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0B0F19] flex items-center justify-center px-4" data-testid="admin-login-page">
      <div className="max-w-sm w-full">
        <div className="flex items-center gap-2.5 justify-center mb-8">
          <img
            src="https://customer-assets-jai6qajn.emergentagent.net/job_student-genius-26/artifacts/kbshcq5q_Branding-02.png"
            alt="SmartGuru Logo Icon"
            className="h-9 w-9 object-contain"
          />
          <p className="font-heading font-extrabold text-lg"><span className="bg-gradient-to-r from-[#B96AD1] via-[#8B88E0] to-[#F080BC] bg-clip-text text-transparent">SmartGuru.io</span> <span className="text-white">Admin</span></p>
        </div>
        <form onSubmit={submit} className="bg-card border border-border rounded-3xl shadow-2xl p-7 space-y-4" data-testid="admin-login-form">
          <div className="w-12 h-12 rounded-2xl bg-primary/10 flex items-center justify-center mb-2">
            <Lock className="text-primary" size={22} />
          </div>
          <div>
            <label className="text-xs font-bold text-muted-foreground uppercase tracking-wide">Admin Email</label>
            <input
              type="email"
              data-testid="admin-email-input"
              value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })}
              className="w-full mt-1.5 h-11 rounded-xl border border-border bg-background px-3.5 text-sm focus:outline-none focus:ring-2 focus:ring-primary/40"
              placeholder="admin@smartguru.io"
            />
          </div>
          <div>
            <label className="text-xs font-bold text-muted-foreground uppercase tracking-wide">Password</label>
            <input
              type="password"
              data-testid="admin-password-input"
              value={form.password}
              onChange={(e) => setForm({ ...form, password: e.target.value })}
              className="w-full mt-1.5 h-11 rounded-xl border border-border bg-background px-3.5 text-sm focus:outline-none focus:ring-2 focus:ring-primary/40"
              placeholder="••••••••"
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            data-testid="admin-login-submit"
            className="w-full h-12 rounded-xl bg-primary text-primary-foreground font-bold flex items-center justify-center gap-2 hover:bg-primary/90 active:scale-95 transition-all disabled:opacity-60"
          >
            <LogIn size={16} /> {loading ? "Logging in..." : "Log In"}
          </button>
        </form>
      </div>
    </div>
  );
}
